import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import UserForm from '../../components/UserForm/UserForm';
import './UserScreen.scss';
import Button from '../../components/_atomic/Button/Button';
import UserSubscriptions from './components/UserSubscriptions/UserSubscriptions';
import PasswordModal from './components/PasswordModal/PasswordModal';
import { SUCCESS } from '../../utils/constants';
import { removeClientLastURL } from '../../utils/helpers';

//

class UserScreen extends Component {
  static propTypes = {
    profile: PropTypes.shape({}).isRequired,
    email: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    updateProfile: PropTypes.func.isRequired,
    updateProfileStatus: PropTypes.string.isRequired,
    updateProfileError: PropTypes.string.isRequired,
    logout: PropTypes.func.isRequired,
    emailSubscriptions: PropTypes.shape({}).isRequired,
    changePassword: PropTypes.func.isRequired,
    changePasswordStatus: PropTypes.string.isRequired,
    changePasswordError: PropTypes.string.isRequired,
    resetChangePasswordStatus: PropTypes.func.isRequired,
    havePassword: PropTypes.bool.isRequired,
    getProfile: PropTypes.func.isRequired,
    sidebarStatus: PropTypes.bool,
  };
  static defaultProps = {
    sidebarStatus: true,
  }
  state = {
    changePasswordVisible: false,
  };

  componentDidUpdate(prevProps) {
    const { changePasswordStatus, getProfile } = this.props;
    if (
      changePasswordStatus !== prevProps.changePasswordStatus &&
      changePasswordStatus === SUCCESS
    ) {
      getProfile();
    }
  }

  openChangePasswordModal = () => {
    this.setState(() => ({
      changePasswordVisible: true,
    }));
  };
  closeChangePasswordModal = () => {
    this.setState(() => ({
      changePasswordVisible: false,
    }));
  };
  render() {
    const {
      profile,
      email,
      id,
      updateProfile,
      updateProfileStatus,
      updateProfileError,
      logout,
      emailSubscriptions,
      changePassword,
      changePasswordStatus,
      changePasswordError,
      havePassword,
      resetChangePasswordStatus,
      sidebarStatus,
    } = this.props;
    const { changePasswordVisible } = this.state;
    const userScreenClassNames = classNames({
      screen: true,
      'user-profile-screen': true,
    });
    const logoutButtonActive = () => {
      removeClientLastURL();
      logout();
    };
    const logoutButtonWrapperClasses = classNames([
      'button-wrapper',
      'logout-button-wrapper',
    ]);

    return (
      <div className={userScreenClassNames}>
        <div className="main-label-no-transform">
          <span>Profile</span>
        </div>

        <div className="form-wrapper">
          <UserForm
            profile={profile}
            updateProfileStatus={updateProfileStatus}
            submitHandler={updateProfile}
            email={email}
            updateProfileError={updateProfileError}
            emailSubscriptions={emailSubscriptions}
            sidebarStatus={sidebarStatus}
            id={id}
          />
        </div>
        <div className="change-password-wrapper">
          <PasswordModal
            isVisible={changePasswordVisible}
            changePasswordError={changePasswordError}
            changePasswordStatus={changePasswordStatus}
            changePassword={changePassword}
            resetChangePasswordStatus={resetChangePasswordStatus}
            closeModal={this.closeChangePasswordModal}
            havePassword={havePassword}
          />
          <div className="button-wrapper">
            <Button
              label={havePassword ? 'Change Password' : 'Add Password'}
              secondary
              clickHandler={this.openChangePasswordModal}
            />
          </div>
        </div>
        <div className="subscriptions-wrapper">
          <UserSubscriptions
            updateProfile={updateProfile}
            emailSubscriptions={emailSubscriptions}
            profile={profile}
            id={id}
          />
        </div>
        <div className={`${logoutButtonWrapperClasses}`}>
          <Button label="Logout" clickHandler={logoutButtonActive} style={{ marginBottom: '10px' }} />
        </div>
      </div>
    );
  }
}

export default UserScreen;



// WEBPACK FOOTER //
// ./src/containers/UserScreen/UserScreen.js